// extracted by mini-css-extract-plugin
export default {"map":"ParticipantHero2023_map_CILvQ","live":"ParticipantHero2023_live_SYYNp","avatar":"ParticipantHero2023_avatar_OgOAw","distance":"ParticipantHero2023_distance_WBais"};